/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popBioMatrixScanCheck.vue?vue&type=template&id=96d7222c&scoped=true"
import script from "./popBioMatrixScanCheck.vue?vue&type=script&lang=js"
export * from "./popBioMatrixScanCheck.vue?vue&type=script&lang=js"
import style0 from "./popBioMatrixScanCheck.vue?vue&type=style&index=0&id=96d7222c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d7222c",
  null
  
)

export default component.exports